import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/homes/Index.vue'
const includPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  		return includPush.call(this, location).catch(err => err)
	}
Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
},
{
    path: "/product",
    name: "Product",
    redirect: '/product/productdetail/1',
    component: () =>
        import("../views/product/Index.vue"),
    children: [
        {
            path: "productdetail/:id",
            name: "ProductDetail",
            component: () =>
                import("../views/product/Product_detail.vue")
        },
        {
            path: "profile/:id",
            name: "ProductContent",
            component: () =>
                import("../views/product/Product_content.vue")
        }

    ]
},
{
    path: "/home/news",
    name: "News",
    component: () =>
        import("../views/homes/News_items.vue")
},
{
    path: "/home/news/:id",
    name: "News",
    component: () =>
        import("../views/homes/News_detail.vue")
},

{
    path: "/solutionindex",
    name: "Solution",
    component: () =>
        import("../views/solution/Index_detail.vue"),

},
{
    path: "/solution",
    name: "Solution",
    component: () =>
        import("../views/solution/Index.vue"),
    children: [
        {
            path: "solutiondetail/:id",
            name: "solutionDetail",
            component: () =>
                import("../views/solution/Product_detail.vue")
        },
        {
            path: "profile/:id",
            name: "ProductContent",
            component: () =>
                import("../views/solution/Product_content.vue")
        }

    ]
},
{
    path: "/operation",
    name: "Operation",
    component: () =>
        import("../views/operation/Index.vue")
},
{
    path: "/investor",
    name: "investoI",
    component: () =>
        import("../views/investor/Index.vue"),
},
{
    path: "/leaving",
    name: "Leaving",
    component: () =>
        import("../views/Leaving/Index.vue")
},
{
    path: "/company",
    name: "Company",
    component: () =>
        import("../views/Company/Index.vue")
},
{
    path: "/detail",
    name: "Detail",
    component: () =>
        import("../views/Company/Detail.vue")
},
{
    path: "/join",
    name: "Join",
    component: () =>
        import("../views/Join/Index.vue")
},
{
    path: "/joinDetail",
    name: "JoinDetail",
    component: () =>
        import("../views/Join/JoinDetail.vue")
},
{
    path: "/unionparty",
    name: "UnionParty",
    component: () =>
        import("../views/Union/UnionParty.vue")
},
{
    path: "/search",
    name: "Search",
    component: () =>
        import("../views/Search/Index.vue")
}
]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,

    routes
})
router.beforeEach((to, from, next) => {
    next()
    window.scrollTo(0, 300)
})
export default router